var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observePerformance } from "@/performance/performance-observer-hooks";
function importApp() {
    return __awaiter(this, void 0, void 0, function* () {
        yield import(
        /* webpackMode: "eager" */
        "@/global");
        yield import(
        /* webpackMode: "eager" */
        "@/sw/sw-controller");
        const mobx = yield import(
        /* webpackMode: "eager" */
        "mobx");
        yield import(
        /* webpackMode: "eager" */
        "./app/App");
        mobx.configure({ enforceActions: "always" });
    });
}
observePerformance().finally(importApp);
// Exports
// External Shared Actions Types
export * from "./store/shared-actions/export-types";
